import { Controller } from "@hotwired/stimulus"

// Cornerstone spike (FD-1295): fills a <cs-dropdown> from the server the first time it
// opens, for a menu too heavy to render into every row (FD-428: the work item "…" menu).
//
//   <cs-dropdown data-controller="dropdown-load"
//                data-action="cs-show->dropdown-load#load"
//                data-dropdown-load-src-value="/…/actions_menu">
//     <cs-button slot="trigger">…</cs-button>
//     <cs-dropdown-item disabled data-dropdown-load-target="placeholder">Loading…</cs-dropdown-item>
//   </cs-dropdown>
//
// The response is bare markup (items, dividers, hidden forms), and it is added to the
// dropdown itself. A turbo-frame in between would not do: cs-dropdown counts only its own
// children as items, so items inside a frame could be clicked but never reached with the
// arrow keys.
//
// Loading happens while a placeholder is present. A morph of a closed menu puts the
// server's placeholder back, so the next open fetches fresh items.
//
// FD-568: an OPEN menu, this one included, is kept out of Turbo morphs by the page-wide
// guard in lib/cornerstone.js, so a refresh doesn't close it under the person using it.

export default class extends Controller {
  static targets = ["placeholder"]
  static values = { src: String }

  async load(event) {
    // cs-show bubbles, so ignore one from anything nested inside the menu.
    if (event.target !== this.element) return
    if (!this.hasSrcValue || !this.hasPlaceholderTarget || this.loading) return

    this.loading = true
    try {
      // manual: a redirect (a guest bounced, an expired session) must not pour a whole
      // page into the menu. It comes back as a non-ok opaque response instead.
      const response = await fetch(this.srcValue, {
        headers: { Accept: "text/html" },
        credentials: "same-origin",
        redirect: "manual"
      })
      if (!response.ok) throw new Error(`menu request failed (${response.status})`)

      const template = document.createElement("template")
      template.innerHTML = await response.text()
      this.placeholderTargets.forEach((placeholder) => placeholder.remove())
      this.element.append(template.content)
    } catch (_error) {
      // Leave the placeholder in place, so the next open tries again.
      this.placeholderTargets.forEach((placeholder) => { placeholder.textContent = "Couldn’t load. Close and try again." })
    } finally {
      this.loading = false
    }
  }
}
